import { SETPAY } from 'const/account/products'
import { SYF_NUMBER, SYF_SI_NUMBER, helpNumbers } from 'const/helpNumbers'
import { ProductType } from '@syf-api-library/account-summary'
import isAccountTypeSecuredInstallment from 'helpers/isAccountTypeSecuredInstallment'
import { SECURED_INSTALLMENT } from 'const/productTypes'

const getHelpNumber = (
  client: string,
  product: ProductType | typeof SECURED_INSTALLMENT
): string => {
  const { amazon, lowes, sams } = helpNumbers
  if (isAccountTypeSecuredInstallment(product)) {
    return SYF_SI_NUMBER
  }
  if (product === SETPAY) {
    switch (client) {
      case 'amazon':
        return amazon
      case 'lowes':
        return lowes
      case 'sams':
        return sams
      default:
        return SYF_NUMBER
    }
  }
  return SYF_NUMBER
}

export default getHelpNumber
